import { useEffect, useMemo, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FaUser, FaMapMarkerAlt, FaFutbol, FaArrowRight, FaDownload, FaSearch, FaUsers, FaBolt } from "react-icons/fa";
import { get } from "../http/api";
import "./OfferApplications.css";
import { useTranslation } from "react-i18next";
import { UPLOADS_URL } from "../config";
import { getMediaUrl } from "../http/media";


export default function OfferApplications() {

    const { id } = useParams();

    const navigate = useNavigate();

    const [applications, setApplications] = useState([]);

    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState("");

    const { t } = useTranslation();

    const filteredApplications = useMemo(() => {
        const query = searchQuery.trim().toLocaleLowerCase();
        if (!query) return applications;

        return applications.filter((user) =>
            [
                user.firstname,
                user.lastname,
                user.username,
                user.country,
                user.position,
                user.staff_position,
                user.age
            ]
                .filter(Boolean)
                .some((value) => String(value).toLocaleLowerCase().includes(query))
        );
    }, [applications, searchQuery]);

    const navigateWithTransition = (target) => {
        if (document.startViewTransition) {
            document.startViewTransition(() => navigate(target));
        } else {
            navigate(target);
        }
    };


    useEffect(() => {
        fetchApplications();
    }, []);


    const fetchApplications =
        async () => {

            try {

                const res =
                    await get(

                        `offers/${id}/applications`

                    );

                setApplications(

                    res.data || []

                );

            }
            catch (err) {

                if (
                    err.message ===
                    "ACCESS_DENIED"
                ) {

                    navigate(
                        "/home"
                    );

                    return;
                }

            }
            finally {

                setLoading(false);

            }

        };


    return (

        <div className="applications-page">
            <button
                className="sport-back-btn"
                onClick={() => navigateWithTransition(-1)}
                style={{ marginBottom: "20px" }}
            >
                <span className="back-arrow">←</span>

                <div className="back-content">
                    <span className="back-label">
                        {t("offerApplications.back.label")}
                    </span>

                    <small>
                        {t("offerApplications.back.subtitle")}
                    </small>
                </div>
            </button>

            <div className="applications-header">

                <div>
                    <span className="applications-kicker"><FaBolt /> {t("offerApplications.header.kicker")}</span>

                    <h1>
                        {t("offerApplications.header.title")}
                    </h1>

                    <p>
                        {t("offerApplications.header.description")}
                    </p>

                </div>

                <div className="applications-signal">
                    <FaUsers />
                    <strong>{applications.length}</strong>
                </div>
            </div>

            <div className="applications-toolbar">
                <label className="applications-search">
                    <FaSearch aria-hidden="true" />
                    <input
                        type="search"
                        value={searchQuery}
                        onChange={(event) => setSearchQuery(event.target.value)}
                        placeholder={t("offerApplications.search.placeholder")}
                        aria-label={t("offerApplications.search.placeholder")}
                    />
                    {searchQuery && (
                        <button type="button" onClick={() => setSearchQuery("")} aria-label={t("offerApplications.search.clear")}>×</button>
                    )}
                </label>
                <span className="applications-result-count">
                    <b>{filteredApplications.length}</b> {t("offerApplications.search.results")}
                </span>
            </div>

            <div className="applications-grid">

                {

                    loading ?

                        Array.from(
                            { length: 6 }
                        ).map((_, i) => (

                            <div
                                className="application-skeleton"
                                key={i}
                            />

                        ))

                        :

                        filteredApplications.length === 0 ?

                            <div
                                className="applications-empty"
                            >

                                <h3>
                                    {searchQuery ? t("offerApplications.search.emptyTitle") : t("offerApplications.empty.title")}
                                </h3>

                                <p>
                                    {searchQuery ? t("offerApplications.search.emptyDescription") : t("offerApplications.empty.description")}
                                </p>

                            </div>

                            :

                            filteredApplications.map(
                                user => (
                                    <div
                                        key={
                                            user.id
                                        }

                                        className="application-card"
                                    >

                                        <div
                                            className="application-top"
                                        >

                                            {

                                                user.image ?

                                                    <img

                                                        // src={`${UPLOADS_URL}/${user.image}`}
                                                        src={getMediaUrl(user.image)}

                                                        alt=""

                                                    />

                                                    :

                                                    <div
                                                        className="avatar-fallback"
                                                    >

                                                        <FaUser />

                                                    </div>

                                            }

                                            <div>

                                                <h3>

                                                    {
                                                        user.firstname
                                                    }

                                                    &nbsp;

                                                    {
                                                        user.lastname
                                                    }

                                                </h3>

                                                <p>

                                                    @
                                                    {
                                                        user.username
                                                    }

                                                </p>

                                            </div>

                                        </div>


                                        <div
                                            className="application-info"
                                        >

                                            <div>

                                                <FaMapMarkerAlt />

                                                {
                                                    user.country ||
                                                    "-"
                                                }

                                            </div>

                                            <div>

                                                <FaFutbol />

                                                {
                                                    user.position ||
                                                    user.staff_position ||
                                                    "-"
                                                }

                                            </div>

                                            <div>

                                                {t("offerApplications.profile.age")} :

                                                {
                                                    user.age ||
                                                    "-"
                                                }

                                            </div>

                                        </div>

                                        {

                                            user.cv_file && (

                                                <button

                                                    className="download-cv-btn"

                                                    onClick={(e) => {

                                                        e.stopPropagation();
                                                        window.open(
                                                            getMediaUrl(
                                                                user.cv_file,
                                                                "document"
                                                            ),
                                                            "_blank"
                                                        );

                                                    }}

                                                >

                                                    <FaDownload />
                                                    {t("offerApplications.buttons.downloadCv")}

                                                </button>

                                            )

                                        }


                                        <button

                                            className="view-profile-btn"

                                            onClick={() => {

                                                navigate(

                                                    `/user/${user.username}`

                                                );

                                            }}

                                        >

                                            {t("offerApplications.buttons.viewProfile")}

                                            <FaArrowRight />

                                        </button>

                                    </div>

                                )

                            )

                }

            </div>

        </div>

    );

}
